import get from "lodash/get";
import keyBy from "lodash/keyBy";
import { normalizeDate } from "../helpers/date";
export var getUniqueCartItemId = function (priceId, parentPriceId, timespanId, dirtyDateSlot) {
    var _a, _b;
    var dateSlot = !!(dirtyDateSlot === null || dirtyDateSlot === void 0 ? void 0 : dirtyDateSlot.from) && ((_b = (_a = normalizeDate(dirtyDateSlot === null || dirtyDateSlot === void 0 ? void 0 : dirtyDateSlot.from)).toISOString) === null || _b === void 0 ? void 0 : _b.call(_a));
    dateSlot = !dateSlot ? '' : "d_" + dateSlot;
    priceId = !priceId ? '' : "p_" + priceId;
    parentPriceId = !parentPriceId ? '' : "pp_" + parentPriceId;
    timespanId = !timespanId ? '' : "t_" + timespanId;
    if (parentPriceId && priceId) {
        return [parentPriceId, priceId, dateSlot].filter(Boolean).join("_");
    }
    if (parentPriceId) {
        return [parentPriceId, dateSlot].filter(Boolean).join("_");
    }
    if (priceId) {
        return [priceId, dateSlot].filter(Boolean).join("_");
    }
    if (timespanId) {
        return [timespanId, dateSlot].filter(Boolean).join("_");
    }
    return "dropped_p_" + priceId + "_t_" + timespanId + "_" + new Date().getTime();
};
export var getUniqueCartItemsByKey = function (modelManager, cartItems) {
    var _a, _b;
    var parentBookingSlot = (_b = (_a = cartItems[0]) === null || _a === void 0 ? void 0 : _a.bookingSlot) !== null && _b !== void 0 ? _b : null;
    return keyBy(cartItems, function (o) {
        var timespanId = get(o, "booking.course_timespan_id");
        var timespanModel = modelManager === null || modelManager === void 0 ? void 0 : modelManager.courseTimespans().findById(timespanId);
        var dirtyPriceId = get(o, "position.price_id");
        var dirtyQuantity = get(o, "position.quantity", "");
        var parentPriceId = get(o, "position.parent_price_id");
        var bookingSlot = get(o, "bookingSlot");
        var priceId = parentPriceId
            ? dirtyPriceId
            : derivePriceId(timespanModel, dirtyPriceId, dirtyQuantity);
        if (!parentPriceId)
            parentBookingSlot = (bookingSlot !== null && bookingSlot !== void 0 ? bookingSlot : null);
        return getUniqueCartItemId(priceId, parentPriceId, timespanId, parentBookingSlot);
    });
};
export var derivePriceId = function (timespanModel, priceId, quantity) {
    var count = (timespanModel === null || timespanModel === void 0 ? void 0 : timespanModel.getAvailablePrices({ quantity: quantity }).size) || 0;
    switch (count) {
        case 0: return "";
        case 1: return String(timespanModel.getAvailablePrices({ quantity: quantity }).first().id);
        default: return priceId;
    }
};
